import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as StorySelectors from "../../data/stories/StorySelectors";

import * as StoryActions from "../../data/stories/StoryActions";
import * as IntegrationsActions from "../../data/integrations/IntegrationsActions";

import ShareDialog from './ShareDialog';

class ShareDialogContainer extends React.Component
{
    state = {
        loading: true
    };

    componentDidMount()
    {
        // Promise.all([
        //     this.props.listIntegrations()
        // ]).then(() => this.setState({loading: false}));

        this.setState({loading: false});
    }

    render()
    {
        return <ShareDialog {...this.state} {...this.props} />;
    }
}

const mapStateToProps = (state, ownProps) => ({
    integrations: state.integrations,
});

const mapDispatchToProps = {
    createPosts: StoryActions.createPosts,
    listIntegrations: IntegrationsActions.listIntegrations
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareDialogContainer);
